import React from 'react'
import { Container, Header , Button} from 'semantic-ui-react'
import "./Section1.css"

const Section1 = () => {
    return <Container className="Section1 p-2">
        <div className="main-bg">
            <Header inverted as="h1" className="m-8-t">Not sure where to go? Perfect.</Header>
            <Button inverted className="rounded-50"  size='big'>
                I'm flexible
            </Button>
        </div>
    </Container>
}
 export default Section1